'use strict';

module.exports = function formatComplex(element, data, context) {
    var cnt = '';
    element.children.forEach(function (part) {
        if (typeof part === 'string') {
            cnt += part;
        }
        else {
            cnt += part.resolve(data, context);
        }
    });
    return cnt;
};
